var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallAListenerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67962 4.05722L6.02974 3.70711C6.42026 3.31658 7.05342 3.31658 7.44395 3.70711L9.81921 6.08237C10.2097 6.47289 10.2097 7.10606 9.81921 7.49658L8.15835 9.15744C7.8752 9.44059 7.805 9.87316 7.98408 10.2313C9.01933 12.3018 10.6982 13.9807 12.7687 15.0159C13.1268 15.195 13.5594 15.1248 13.8426 14.8416L15.5034 13.1808C15.8939 12.7903 16.5271 12.7903 16.9176 13.1808L19.2929 15.5561C19.6834 15.9466 19.6834 16.5797 19.2929 16.9703L18.9428 17.3204C16.8314 19.4317 13.4889 19.6693 11.1001 17.8777L10.3128 17.2872C8.56925 15.9796 7.02043 14.4307 5.71278 12.6872L5.12226 11.8999C3.33072 9.51114 3.56827 6.16857 5.67962 4.05722Z",
    fill: "#3C87FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallAListenerIcon);
export default __webpack_public_path__ + "static/media/call_a_listener_icon.8772118e857f120207cc3a2f10e73257.svg";
export { ForwardRef as ReactComponent };